import './simpleFields.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { CloseCircleOutlined } from '@ant-design/icons';
import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { SimpleFieldsProps } from 'areas/administration/authentication/types';
import { renderInput } from './utils';

const b = b_.with('simple-fields');

const SECRET_PLACEHOLDER = '••••••••';

export const SimpleFields = observer(({ store }: SimpleFieldsProps) => (
	<Section appearance={'frame'} title={i18n('Setup')} childrenPadding={true} className={b()}>
		{store.fields.map((field) => (
			<FormEntryNew
				key={field.name}
				label={i18n(field.label)}
				placeholder={store.stored[field.name] ? SECRET_PLACEHOLDER : undefined}
				hasPlaceholder={store.stored[field.name]}
				model={store.model}
				modelField={field.name}
				validator={store.validator}
				disabled={store.readOnly}
				headerAdditionalContent={
					store.isClearable(field) ? (
						<CloseCircleOutlined
							className={b('clear')}
							title={i18n('Clear field')}
							onClick={() => store.clear(field)}
						/>
					) : undefined
				}
			>
				{renderInput(field)}
			</FormEntryNew>
		))}
	</Section>
));
